// project import
import MainLayout from 'layout/MainLayout';
import AuthGuard from 'utils/route-guard/AuthGuard';
import ApplicationsRoutes from './ApplicationsRoutes';

const MainApplicationsRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [ApplicationsRoutes]
    }
  ]
};

export default MainApplicationsRoutes;
